import { api } from './client';

// ---------- Step-6A Admin Threat Telemetry API ----------------------------
export const fetchThreatSnapshot = () => api.get('/api/admin/threat/snapshot').then((r) => r.data);

export const fetchTopIps = (topN = 10) => api.get('/api/admin/threat/top-ips', { params: { top_n: topN } }).then((r) => r.data);

export const fetchActiveBans = (page = 1) => api.get('/api/admin/threat/bans', { params: { page } }).then((r) => r.data);

export const liftBan = (ip) => api.post(`/api/admin/threat/bans/${encodeURIComponent(ip)}/lift`).then((r) => r.data);

export const manualBan = (ip, reason, ttlSeconds = 1800) => api.post('/api/admin/threat/bans', { ip, reason, ttl_seconds: ttlSeconds }).then((r) => r.data);
